var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.comparisonItem === 'PROVIDER')?_c('product-provider',{attrs:{"currentPackage":_vm.currentPackage}}):_c('div',[_vm._v(_vm._s(_vm.comparisonItem))])
}
var staticRenderFns = []

export { render, staticRenderFns }